import { render } from "./Modal_View_Departament.vue?vue&type=template&id=3e6dc408&scoped=true"
import script from "./Modal_View_Departament.vue?vue&type=script&lang=js"
export * from "./Modal_View_Departament.vue?vue&type=script&lang=js"

import "./Modal_View_Departament.vue?vue&type=style&index=0&id=3e6dc408&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6dc408"]])

export default __exports__